import { useFormikContext } from "formik";
import React, { useRef } from "react"
import { findField, updateField } from "@app/utils/form";
import { useTypicalRisks } from "@app/components/inspection-form/TypicalRisksObserver.jsx"
import { bodyPartsList } from "@app/components/BodypartSelector/BodypartSelector"

export const usePhysicalDangerObserver = (currentFieldsets, otherProps) => {
    const { values } = useFormikContext();

	// patch field "physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung"
	// save the initial options
	const field = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung")
	const { risks, jobId } = useTypicalRisks(otherProps.globalValues);
	let res = React.useMemo(() => {
		if (field) {
			const bodyPartOptions = bodyPartsList.map((part) => ({
				"label": part,
				"value": part,
				"selected": false,
				"displayPrimary": true
			}))
			field.defaultOptions ??= field.options
			field.options = field.defaultOptions.toSpliced(1, 0, ...risks.map(risk => ({label: risk, value: risk, selected: false, displayPrimary: true,
				koerperteile: bodyPartOptions})))
			return {
				fieldsets: currentFieldsets
			}
		}
		return {
			fieldsets: currentFieldsets
		}
	}, [field])
	return res;
};
